// Service domain types
export interface Service {
  id: string;
  code: string;
  name: string;
  categoryId: string;
  categoryName?: string;
  price: number;
  unit?: string; // Đơn vị tính (cuốn, cái, giờ, lượt, km, m2, ...)
  defaultPrice?: number; // Service base price (same as price, for clarity in order context)
  customPrice?: number; // Customer-specific or group price from CustomerPrice table
  sourcePrice?: string; // Price source: customer_specific, customer_group, service_base
  status: ServiceStatus;
  room: string;
  serviceLinesId?: string[];
  serviceLines?: ServiceLine[];
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceLine {
  id: string;
  code: string;
  serviceId: string;
  materialId: string;
  materialName?: string;
  quantity: number;
  loseRate: number;
  createdAt: string;
  updatedAt: string;
}

// Service status constants from backend (entity.go)
export const SERVICE_STATUS_SELLING = 'selling';
export const SERVICE_STATUS_PENDING = 'pending';
export const SERVICE_STATUS_STOP = 'stop';

// Service status based on backend constants
export type ServiceStatus = typeof SERVICE_STATUS_SELLING | typeof SERVICE_STATUS_PENDING | typeof SERVICE_STATUS_STOP;

// Service status options for UI
export const SERVICE_STATUS_OPTIONS = [
  { value: SERVICE_STATUS_SELLING, label: 'services.status.selling' },
  { value: SERVICE_STATUS_PENDING, label: 'services.status.pending' },
  { value: SERVICE_STATUS_STOP, label: 'services.status.stop' },
] as const;

// Form interfaces
export interface CreateServiceRequest {
  name: string;
  categoryId: string;
  price: number;
  unit?: string;
  status?: ServiceStatus;
  room: string;
}

export interface UpdateServiceRequest extends Partial<CreateServiceRequest> {
  id: string;
}

// Filter and search interfaces
export interface ServiceFilters {
  search?: string;
  status?: ServiceStatus[];
  categoryId?: string[];
  priceFrom?: number;
  priceTo?: number;
  room?: string[];
  createdFrom?: string;
  createdTo?: string;
  customerCode?: string; // Optional customer code for pricing lookup
}

// API response interfaces
export interface ServiceListResponse {
  data: Service[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ServiceDetailResponse {
  service: Service;
  serviceLines: ServiceLine[];
  totalServiceLines: number;
}

// UI state interfaces
export interface ServiceColumnVisibility {
  code: boolean;
  name: boolean;
  category: boolean;
  price: boolean;
  unit: boolean;
  status: boolean;
  room: boolean;
  serviceLines: boolean;
  createdAt: boolean;
  actions: boolean;
}

// Type counts for filter tabs
export interface ServiceTypeCounts {
  all: number;
  selling: number;
  pending: number;
  stop: number;
}

// Service room constants (based on backend)
export const SERVICE_ROOMS = [
  'No',
  'Printing Room 1',
  'Printing Room 2',
] as const;

export type ServiceRoom = typeof SERVICE_ROOMS[number];
